module.exports = __webpack_public_path__ + "static/media/map-pin.54dd529b.svg";